/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import * as Sentry from "@sentry/react";

import { entitySlice } from './entities';
import userReducer from './user';
import uiReducer from './ui';
import upperLevelReducer from './upperLevelReducers';

import type { AppState } from '.';


const persistConfig = {
	key: "root",
	storage,
	whitelist: ["user"],
};

export const uncoupledReducer = combineReducers({
	user: userReducer,
	entity: entitySlice.reducer,
	ui: uiReducer,
	// navigator: createRouterReducer(history)
});

const combinedReducer = combineReducers({
	user: userReducer,
	entity: entitySlice.reducer,
	ui: uiReducer,
});

export const rootReducer = (state, action) => {
	const intermediateState = upperLevelReducer(state, action);
	const finalState = combinedReducer(intermediateState, action);
	return finalState;
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
	actionTransformer: (action) => {
		if (action.type === "user/attemptLogin") return null;
		if (action.type === "user/attemptRefresh") return null;
		if (action.type === "user/loadData/thunk") {
			const workingLoadUserDataAction = {
				...action,
				payload: {
					...action.payload,
					jwt: null,
					refreshJwt: null
				}
			};
			return workingLoadUserDataAction;
		}
		return action;
	},
	stateTransformer: (state: AppState) => {
		const transformedState = {
			...state,
			user: {
				jwt: null,
				refreshJwt: null
			}
		}
		return transformedState;
	}
});

// Configuration step.
const configurePowerShadesStore = () => {
	const store = configureStore({
		reducer: persistedReducer,
		middleware: (getDefaultMiddleware) =>
			[
				...getDefaultMiddleware({
					serializableCheck: false,
				}),
				// isDevelopment ? require('redux-immutable-state-invariant').default() : null
			]
		,
		enhancers: [sentryReduxEnhancer]
	});

	return store;
};

const store = configurePowerShadesStore();

const persistor = persistStore(store);

export { persistor, store };
